import React, { Component } from 'react';
var moment = require('moment');
import {minToSize, range} from '../utils/utils.js';
import CustomCurrencyInput from './CustomCurrencyInput';
import CustomCuilInput from './CustomCuilInput';
import AdaptedTextArea from './AdaptedTextArea';

require(`../assets/${process.env.PAGE}/css/components/dynamic-label.css`);
import { SingleDatePicker, isInclusivelyAfterDay } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import CustomNomenclatureInput from './CustomNomenclatureInput.js';
require(`../assets/${process.env.PAGE}/css/custom-date-picker.css`);

class DynamicLabelInput extends Component {

    constructor(props) {
        super(props);
        this.state = {showLabel: (false || this.props.value) };
        this.onChangeHandler = this.onChangeHandler.bind(this);
    }

    onChangeHandler(event) {
        const { type, onChange, maxLength, limit } = this.props;
        let value;
        if((moment.isMoment(event)) || (this.props.type === 'currency') || (this.props.type === 'cuil') || (this.props.type === 'nomenclature')){
            value = event;
        }else{
            value = event.target.value;
        }
        if((!value && type!=='currency') || (!value && type!=='cuil') || (value==='false' && type==='select') || (isNaN(value) && type==='currency')){
            this.setState({showLabel: false})
        } else{
            this.setState({showLabel: true})
        }
        if(type === 'number'){
            if((value.length > maxLength) && maxLength){
                return;
            }
            if ((value > limit) && limit) {
                return;
            }
        }
        onChange(event);
    }

    render() {
        const { type, showLabel, description, ...field_props } = this.props;
        const label = showLabel && this.state.showLabel && (<div className={`dynamic-label${ type === 'textarea' ? '-textarea' : ''}`}>
                                                <span>{field_props.placeholder}</span>
                                               </div>);
        const description_element = description && (<div className='dynamic-label-description'>{description}</div>);
        let input_element= false;

        switch(type){
            case('currency'):
                input_element = (<CustomCurrencyInput {...field_props} onChange={this.onChangeHandler} autoComplete="sdf"/>);
                break;
            case('cuil'):
                input_element = (<CustomCuilInput {...field_props} onChange={this.onChangeHandler} autoComplete="sdf"/>);
                break;
            case('nomenclature'):
                input_element = (<CustomNomenclatureInput {...field_props} onChange={this.onChangeHandler} autoComplete="sdf"/>);
                break;
            case('select'):
                input_element = (<select {...field_props} onChange={this.onChangeHandler} className={field_props.className}>
                                    {this.props.children}
                                </select>);
                break;
            case('textarea'):
                input_element = (<AdaptedTextArea {...field_props} onChange={this.onChangeHandler} className={field_props.className}/>);
                break;
            case('calendar'):
                input_element = (<SingleDatePicker
                                    date={field_props.value || null} // momentPropTypes.momentObj or null
                                    onDateChange={this.onChangeHandler} // PropTypes.func.isRequired
                                    placeholder={field_props.placeholder} 
                                    focused={field_props.focused} // PropTypes.bool
                                    onFocusChange={field_props.onFocusChange} // PropTypes.func.isRequired
                                    displayFormat={'DD/MM/YYYY'}
                                    id="your_unique_id" // PropTypes.string.isRequired,
                                    numberOfMonths={1}
                                    withFullScreenPortal={minToSize(576)}
                                    noBorder={true}
                                    readOnly
                                    block
                                    hideKeyboardShortcutsPanel={true}
                                    isOutsideRange={function(day) { return isInclusivelyAfterDay(day, moment().add(1, 'days'))}}
                                    renderMonthElement={this.props.renderMonthElement && (({ month, onMonthSelect, onYearSelect }) => {
                                        return (
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                          <div>
                                            <select
                                              value={month.month()}
                                              onChange={(e) => { onMonthSelect(month, e.target.value); }}
                                            >
                                              {moment.monthsShort().map((label, value) => (
                                                <option value={value}>{label}</option>
                                              ))}
                                            </select>
                                          </div>
                                          <div>
                                            <select
                                              value={month.year()}
                                              onChange={(e) => { onYearSelect(month, e.target.value); }}
                                            > 
                                              {[...range((moment().year()-70), moment().year())].map((year)=>(
                                                <option value={year}>{year}</option>
                                              ))}
                                            </select>
                                          </div>
                                        </div>
                                      )
                                    })}
                                />);
                break;
            case('number'):
                input_element = (<input {...field_props} type={type}
                                        onKeyDown={ e => ( e.keyCode === 69 || e.keyCode === 107 ||
                                            e.keyCode === 109 || e.keyCode === 187 || e.keyCode === 189 ||
                                            e.keyCode === 190 ) && e.preventDefault() }
                                        onChange={this.onChangeHandler}/>);
                break;
            default:
                input_element = (<input {...field_props} type={type} onChange={this.onChangeHandler}/>);
                break;

        }

        return (<div className={!this.state.showLabel && "dynamic-label-default"}>
                    {(label)}
                    {input_element}
                    {description_element}
                </div>);
    }
}

export default DynamicLabelInput;


/** WEBPACK FOOTER **
 ** ./src/components/DynamicLabelInput.js
 **/